export default "__VITE_ASSET__DW7rG4Gl__"